import { isFulfilled } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import { fetchInvoicesByNumbers } from "../invoiceDetailedSlice";

const usePreviewInvoices = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const previewInvoices = (invoices: string[]) => {
    dispatch(fetchInvoicesByNumbers(invoices)).then(
      (action) =>
        isFulfilled(action) &&
        navigate(`/home/invoices/preview/${invoices.join(",")}`),
    );
  };

  return previewInvoices;
};

export default usePreviewInvoices;
